import script from "./SkillItemComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./SkillItemComponent.vue?vue&type=script&setup=true&lang=js"

import "./SkillItemComponent.vue?vue&type=style&index=0&id=7a975a1e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a975a1e"]])

export default __exports__